import { render, staticRenderFns } from "./TheModal.vue?vue&type=template&id=58f6d157&scoped=true&"
import script from "./TheModal.vue?vue&type=script&lang=js&"
export * from "./TheModal.vue?vue&type=script&lang=js&"
import style0 from "./TheModal.vue?vue&type=style&index=0&id=58f6d157&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f6d157",
  null
  
)

component.options.__file = "TheModal.vue"
export default component.exports